import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Component as r } from "react";
import e from "prop-types";
var o = {
  children: e.oneOfType([e.node, e.arrayOf(e.node)]).isRequired
};
var t = /*#__PURE__*/function (_r) {
  _inherits(t, _r);
  function t(r) {
    var _this;
    _classCallCheck(this, t);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, r)), _this.state = {
      hasError: !1,
      error: null,
      errorInfo: null
    };
    return _this;
  }
  _createClass(t, [{
    key: "componentDidCatch",
    value: function componentDidCatch(r, e) {
      this.setState({
        hasError: !0,
        error: r,
        errorInfo: e
      }), console.warn(e);
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.hasError ? null : this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(r) {
      return {
        hasError: !0
      };
    }
  }]);
  return t;
}(r);
t.propTypes = o;
export { t as default };